import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { reassuranceItems } from '@/mocks/admissionData';

export default function ReassuranceSection() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('admission.reassure.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('admission.reassure.title')}
          </h2>
          {String(t('admission.reassure.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">{__s}</p>))}
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-6"></div>
          {String(t('admission.reassure.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {reassuranceItems.map((item, idx) => (
            <div
              key={idx}
              className="card-glow bg-background-50 border border-background-200/60 p-6 group"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500/10 mb-5">
                <i className={`${item.icon} text-accent-600 text-lg`}></i>
              </div>
              <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.05em] mb-1">
                {lang === 'en' ? t(`admission.reassure.item.${idx}.title`) : item.title}
              </h3>
              <p className="text-[12px] text-foreground-400 tracking-[0.1em] mb-4 font-label">
                {item.titleEn}
              </p>
              <p className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed">
                {lang === 'en' ? t(`admission.reassure.item.${idx}.desc`) : item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <img
            src="/images/generated/admission-reassurance-2026.jpg"
            alt={t('admission.reassure.imgCaption')}
            className="w-full h-auto"
          />
          {String(t('admission.reassure.imgCaption')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-400 tracking-[0.04em] mt-3 text-center">{__s}</p>))}
        </div>
      </div>
    </section>
  );
}
